import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import {
  attachTable,
  getTables,
  selectTables,
} from "../../redux/features/table/TableSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import attactImg from "../../Asset/attach.png";
import { selectDayStatus } from "../../redux/features/dayStart/DayStartSlice";
import { toast } from "react-toastify";
import {
  filterPreTables,
  filterTables,
  selectFilteredTables,
} from "../../redux/features/filter/FilterSlice";

const TableNo = ({ setTableNo }) => {
  const tables = useSelector(selectTables);
  const dayStatus = useSelector(selectDayStatus);
  const filteredTables = useSelector(selectFilteredTables);
  const [search, setSearch] = useState("");
  const [searchPre, setSearchPre] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTables());
  }, [dispatch]);
  const navigate = useNavigate();
  const handleSubmit = (tableNo) => {
    if (dayStatus) {
      setTableNo(tableNo);
      navigate("/orders");
    } else {
      toast.error("Day is closed. Cannot place orders.");
    }
  };
  const handleAttachTable = async (tableNo) => {
    if (tableNo) {
      await dispatch(attachTable(tableNo));
      dispatch(getTables());
    }
  };

  useEffect(() => {
    setSearchPre("");
    dispatch(filterTables({ search, tables }));
  }, [dispatch, search, tables]);
  useEffect(() => {
    dispatch(filterPreTables({ searchPre, tables }));
  }, [dispatch, searchPre, tables]);
  return (
    <div className="overflow-hidden  flex flex-col h-screen bg-[#F1F1F1]">
      <Navbar page={"Table No"} />

      <div className="w-full md:p-8 p-4 relative overflow-y-auto h-full   scrollbar-hide ">
        {/* Product List */}

        {tables?.length > 0 ? (
          <>
            <div className="flex flex-col lg:justify-end justify-start gap-2  my-6 md:mx-10 mx-6 items-center ">
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-xl outline-none"
                placeholder="Search by Table No."
              />
              <div className="flex flex-wrap justify-center gap-2">
                <button
                  onClick={() => setSearchPre("f-")}
                  className={`p-2  rounded-md text-white font-semibold ${
                    searchPre === "f-" ? "bg-[#0D868C]" : "bg-[#a9a9a9]"
                  } `}
                >
                  Family
                </button>
                <button
                  onClick={() => setSearchPre("g-")}
                  className={`p-2  rounded-md text-white font-semibold ${
                    searchPre === "g-" ? "bg-[#0D868C]" : "bg-[#a9a9a9]"
                  } `}
                >
                  Gents
                </button>
                <button
                  onClick={() => setSearchPre("f l-")}
                  className={`p-2  rounded-md text-white font-semibold ${
                    searchPre === "f l-" ? "bg-[#0D868C]" : "bg-[#a9a9a9]"
                  } `}
                >
                  Family Lawn
                </button>
                <button
                  onClick={() => setSearchPre("g l-")}
                  className={`p-2  rounded-md text-white font-semibold ${
                    searchPre === "g l-" ? "bg-[#0D868C]" : "bg-[#a9a9a9]"
                  } `}
                >
                  Gents Lawn
                </button>
              </div>
            </div>
            <div className="flex justify-center items-center  md:gap-6 gap-3  flex-wrap">
              <div
                onClick={() => {
                  handleSubmit("parcel");
                }}
                className={` md:w-52 w-36 bg-[#9fa09fa8] cursor-pointer md:h-44 h-28 relative overflow-hidden md:rounded-2xl rounded-lg md:p-4 p-2 flex flex-col justify-between items-center`}
              >
                <h1 className="flex-1 flex-grow flex justify-center items-center text-white md:text-[1.5rem] text-[1.2rem]  uppercase font-semibold">
                  parcel
                </h1>
              </div>
              {filteredTables?.map((table) => (
                <div
                  key={table._id}
                  onClick={() => {
                    if (
                      table?.tableStatus !== "outOfService" &&
                      table?.tableStatus !== "occupied" &&
                      table?.tableStatus !== "attach"
                    ) {
                      handleSubmit(table.tableNo);
                    }
                  }}
                  className={` md:w-52 w-36 md:h-44 h-28 relative ${
                    table?.tableStatus === "outOfService"
                      ? "bg-[#e07c1ea8] cursor-not-allowed"
                      : table?.tableStatus === "vacant"
                      ? "bg-[#9fa09fa8] cursor-pointer"
                      : "bg-[#0D868C] cursor-not-allowed "
                  } overflow-hidden md:rounded-2xl rounded-lg md:p-4 p-2 flex flex-col justify-between items-center`}
                >
                  <h1 className="flex-1 flex-grow flex justify-center items-center text-white md:text-[1.5rem] text-[1.1rem]  uppercase font-semibold">
                    {table?.tableNo}
                  </h1>
                  <div className="flex justify-between items-center border-t md:p-1 p-[2px] md:text-[1rem] text-[.8rem] text-white w-full">
                    <span className=" capitalize">
                      {table?.tableStatus === "outOfService"
                        ? "Out of Service"
                        : table?.tableStatus}
                    </span>
                    {table?.personSpace && <span>{table?.personSpace}</span>}
                  </div>
                  {(table.tableStatus === "vacant" ||
                    table.tableStatus === "attach") && (
                    <button
                      title="Attach Table"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleAttachTable(table.tableNo);
                      }}
                      className="absolute bg-gray-600  md:rounded-lg rounded p-[4px] flex justify-center items-start z-10 md:top-3 md:right-3 top-2 right-2"
                    >
                      <img src={attactImg} className="md:w-6 w-3" alt="" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="w-full flex items-center h-full justify-center">
            no table
          </div>
        )}
      </div>
    </div>
  );
};

export default TableNo;
